/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const IosForward = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.06389 2.5L7 3.55728L15.4954 12L7 20.4427L8.06389 21.5L16.5593 13.0573C17.1469 12.4734 17.1469 11.5266 16.5593 10.9427L8.06389 2.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
